import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";

const mapToOptions = (data, labelKey = 'name', valueKey = 'code') => {
  return data.map(item => ({ label: item[labelKey], value: item[valueKey] }));
};

export const getCourseStatusCounts = async () => {
  try {
    const response = await axiosInstance.get("courses/counts", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching course status counts:", error);
    throw new Error("Failed to fetch course status counts");
  }
};

export const getCourseCountByRole = async () => {
  try {
    const response = await axiosInstance.get("courses/role-count", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching course count by role:", error);
    throw new Error("Failed to fetch course count by role");
  }
};

export const getCourseDetails = async () => {
  try {
    const response = await axiosInstance.get("courses/course-details", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching course details:", error);
    throw new Error("Failed to fetch course details");
  }
};

export const getCourseForRoles = async () => {
  try {
    const response = await axiosInstance.get("courses/courses-Roles", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching course for roles details:", error);
    throw new Error("Failed to fetch course for roles details");
  }
};